<template>
  <v-dialog
    class="folder-rename"
    v-model="dialog"
    width="580"
    lazy
  >

    <slot slot="activator"></slot>
      <v-card>
        <v-card-title>Rename folder</v-card-title>

        <v-card-text>
          <v-text-field :placeholder="currentFolderName" v-model="folderName"/>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="accent"
            outline
            flat
            :disabled="!folderName"
            @click="renameFolder()"
          >
            Rename folder
          </v-btn>
        </v-card-actions>
      </v-card>

  </v-dialog>
</template>

<script>
import axios from "axios"

export default {
  name: "FolderRename",

  props: {
    currentFolderName: {
      type: String,
      required: false
    }
  },

  data: () => ({
    dialog: false,
    folderName: ""
  }),

  methods: {
    renameFolder() {
      this.$emit("renameFolder", this.folderName)
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
